<!-- 新規登録 お気に入りクラブ選択 -->
<template>
    <div class="regist selectClubs">
        <p class="aCt">お気に入りクラブを選択してください。</p>
        <input v-for="league in leagues" :key="league" type="radio" name="league" :id="'league' + league" :value="league" v-model="selectedLeague" class="hiddenTrig">

        <div class="leagueToggle">
            <ul class="selectLeague">
                <li v-for="league in leagues" :key="league" :tabindex="0" @keydown.enter="selectLeague(league)">
                    <label :for="'league' + league"
                           :class="league.toLowerCase()">{{ league }}</label>
                </li>
            </ul>
            <ul v-for="league in leagues"
                :class="['clubList', league.toLowerCase()]">
                <li v-for="club in getSpecifiedClubTeams(league)">
                    <label  :tabindex="getTabIndex(league)"  @keydown.enter="checkFavoriteClub($event, club.clubCode)">
                        <img :src="club.emblemImg | emblemImagePath"
                             :aria-label="`${club.teamName}のお気に入り`"
                             :alt="club.teamName">{{ club.teamName }}
                        <input v-model="favoriteClubs"
                               :value="club.clubCode"
                               name="favorite-status"
                               type="checkbox">
                        <b class="signup" :aria-label="`お気に入りクラブが${getArealabel(favoriteClubs, club.clubCode)}`">★</b>
                    </label>
                </li>
            </ul>

            <p class="aCt">
                <label class="chk" :tabindex="0" @keydown.enter="getReceiveMail">
                    <input v-model="receiveMail"
                           @input="checkbox"
                           tabindex="-1"
                           type="checkbox">
                    <i></i> お気に入りクラブと、Ｊリーグのメールを受け取る
                </label>
            </p>

            <div class="btnSpace duo">
                <button @click="back"
                        type="button"
                        class="return">戻る</button>
                <xhr-button :is-xhr="isXhr"
                            @on-click="next"
                            id="club_regist_tap2"
                            button-label="次へ"></xhr-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mixinJleague } from '../mixin/utility'
import XhrButton from './XhrButton'

export default {
    name: 'FavoriteClubForSignup',
    mixins: [mixinJleague],
    components :{
        'xhr-button': XhrButton,
    },
    data: function(){
        return {
            userInfoPatch: {},
            favoriteClubs: [],
            receiveMail: true,
            leagues: ['J1', 'J2', 'J3'],
            selectedLeague: 'J1'
        }
    },
    props: {
        userinfo: {
            type: Object,
            required: true
        },
        step: {
            type: String,
            default: ''
        },
        isXhr: {
            type: Boolean,
            default: false
        },
        checkReceiveMail: {
            type: Boolean,
            default: true
        }
    },
    created: function(){
        this.userInfoPatch = this.userinfo;
        if (this.userinfo.club_cd){
          this.favoriteClubs = this.userinfo.club_cd.split(',');
        } else {
          this.favoriteClubs = [];
        }
        this.receiveMail = this.checkReceiveMail;
    },
    methods: {
        selectLeague(league) {
            this.selectedLeague = league;
        },
        getTabIndex(league) {
            // 動的に tabIndex を設定するためのメソッド
            return league === this.selectedLeague ? 0 : -1;
        },
        checkFavoriteClub: function(event, clubCode){
            const favoriteClubLabel = event.target;
            target = favoriteClubLabel.querySelector('input');
            target.checked = !target.checked;
            if (target.checked) {
                this.favoriteClubs.push(clubCode);
            }else{
                this.favoriteClubs.splice(this.favoriteClubs.indexOf(clubCode), 1);
            }
        },
        getArealabel(allowedclubCodes, clubCode) {
            if (allowedclubCodes.includes(clubCode)) {
                return 'オンです';
            } else {
                return 'オフです';
            }
        },
        getReceiveMail: function(event){
            target = event.target.querySelector('input');
            this.receiveMail = !target.checked;
            this.checkReceiveMail = !target.checked;
            this.$emit('watch', !target.checked);
            target.checked = !target.checked;
        },
        next: function(){
            if (this.favoriteClubs != null){
                this.userInfoPatch.club_cd = this.favoriteClubs.sort().toString();
            } else {
                this.userInfoPatch.club_cd = null;
            }
            this.$emit('next', this.step, this.userInfoPatch);
        },
        back: function(){
            this.$emit('back', this.step);
        },
        checkbox: function(ev){
            this.$emit('watch', ev.target.checked);
        }
    }
}
</script>
